import { Skeleton, Stack, VisuallyHidden } from '@mantine/core';
import { useTranslate } from '@tolgee/react';

type Props = {
  /** En édition, le formulaire affiche en plus le champ statut. */
  isEdit: boolean;
};

/** Squelette de `AffectationFormDrawer` affiché pendant le chargement des rôles et de l'affectation. */
const AffectationFormDrawerLoader = ({ isEdit }: Props) => {
  const { t } = useTranslate();
  const fieldCount = isEdit ? 3 : 2;

  return (
    <Stack gap="md" role="status" aria-busy="true">
      <VisuallyHidden>{t('profil.affectations.form.loading')}</VisuallyHidden>
      {Array.from({ length: fieldCount }, (_, index) => (
        <Stack key={index} gap={6} aria-hidden="true">
          <Skeleton height={14} width="30%" />
          <Skeleton height={36} />
        </Stack>
      ))}
      <Skeleton height={36} aria-hidden="true" />
    </Stack>
  );
};

export default AffectationFormDrawerLoader;
